import { useEffect, useState } from "react";
import { CheckCircle2, CreditCard, ShieldCheck, Zap } from "lucide-react";
import { getPayvantageUrl } from "../lib/api";
import { Reveal } from "../components/Reveal";
import LeaseCalculator from "../components/LeaseCalculator";

const points = [
  { icon: Zap, text: "Fast application — decisions in minutes" },
  { icon: ShieldCheck, text: "Soft check won't affect your credit score" },
  { icon: CreditCard, text: "Flexible payments with early buyout options" },
  { icon: CheckCircle2, text: "Lease-to-own — the phone becomes yours" },
];

export default function Apply() {
  const [url, setUrl] = useState("#");
  useEffect(() => { getPayvantageUrl().then(setUrl); }, []);

  return (
    <div className="pt-32" data-testid="apply-page">
      <section className="mx-auto grid max-w-7xl items-center gap-14 px-6 pb-24 lg:grid-cols-2 lg:px-12">
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-widest text-crimson">Apply for financing</span>
          <h1 className="mt-3 font-display text-5xl font-black leading-none tracking-tighter text-ink sm:text-6xl">
            Lease your iPhone through <span className="text-crimson">Payvantage</span>
          </h1>
          <p className="mt-6 max-w-lg text-lg text-muted-foreground">
            You'll be securely redirected to the Payvantage application to complete your lease. It takes just a few minutes.
          </p>
          <ul className="mt-8 space-y-4">
            {points.map((p) => (
              <li key={p.text} className="flex items-center gap-3 text-base font-medium text-ink">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-crimson/10">
                  <p.icon className="h-5 w-5 text-crimson" />
                </span>
                {p.text}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="rounded-3xl border border-line bg-white p-8 shadow-xl md:p-10">
            <div className="font-display text-2xl font-bold tracking-tight text-ink">Start your Payvantage lease</div>
            <p className="mt-2 text-muted-foreground">Click below to open the secure Payvantage application in a new tab.</p>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="apply-main-btn"
              className="mt-6 flex w-full items-center justify-center rounded-full bg-crimson py-4 text-base font-bold text-white transition-colors hover:bg-crimson-hover"
            >
              Continue to Payvantage
            </a>
            <p className="mt-4 text-center text-xs text-muted-foreground">
              Payment options are subject to an eligibility check provided by Payvantage lending partners.
            </p>
            <div className="mt-8 rounded-2xl bg-alt p-5 text-sm text-muted-foreground">
              Prefer to talk to a human first? Call or text us at{" "}
              <a href="tel:7709055829" className="font-bold text-crimson" data-testid="apply-phone">(770) 905-5829</a>.
            </div>
          </div>
        </Reveal>
      </section>

      <LeaseCalculator />
    </div>
  );
}
